import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { ScrollText, Reveal } from '../../components/motion';
import ServicePage from './ServicePage/ServicePage';
import courier from './content/courier';
import airport from './content/airport';
import doorToDoor from './content/doorToDoor';
import packing from './content/packing';
import type { ServiceContent } from './content/types';

const SERVICES: Record<string, ServiceContent> = Object.fromEntries(
  [courier, airport, doorToDoor, packing].map((c) => [c.slug, c]),
);

const Services: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const content = slug ? SERVICES[slug] : undefined;

  if (!content) {
    return (
      <Container fluid="xl" className="py-5">
        <ScrollText as="h1" mode="enter">
          Our Services
        </ScrollText>
        <Reveal as="p" className="text-muted" delay={0.15}>
          Coming soon.
        </Reveal>
      </Container>
    );
  }

  return <ServicePage content={content} />;
};

export default Services;
